import { reduce } from '@atlaskit/adf-utils/reduce';
import type { ADFEntity } from '@atlaskit/adf-utils/types';

/**
 * Returns the number of `bodiedSyncBlock` nodes anywhere in `adf` (recursive,
 * counts every instance — multiple occurrences of the same `resourceId`
 * are NOT deduplicated).
 *
 * Used by the convert-to-markdown gesture to decide whether to surface
 * the "Unlink synced blocks to convert" blocker dialog before any other
 * convert-time check (lossy detection, BE flag flip).
 *
 * `undefined` / `null` / non-ADF input → `0`.
 */
export const countSyncBlocks = (adf: unknown): number => {
	if (adf === undefined || adf === null) {
		return 0;
	}
	if (typeof adf !== 'object' || typeof (adf as { type?: unknown }).type !== 'string') {
		return 0;
	}

	return reduce<number>(
		adf as ADFEntity,
		(acc, node) => (node.type === 'bodiedSyncBlock' ? acc + 1 : acc),
		0,
	);
};
